/**
 * 骨架屏指令
 * 用法：v-skeleton="{ loading: true, rows: 3, title: true, avatar: false }"
 * - loading: 是否显示骨架屏
 * - rows: 行数（默认 3）
 * - title: 是否显示标题骨架（默认 true）
 * - avatar: 是否显示头像骨架（默认 false）
 * - width: 标题宽度（默认 '40%'）
 */
var SKELETON_CLASS = 'skeleton-block'
var SKELETON_TITLE_CLASS = 'skeleton-title-block'
var SKELETON_AVATAR_CLASS = 'skeleton-avatar-block'
var SKELETON_ROW_CLASS = 'skeleton-row-block'
var SKELETON_ANIMATE_CLASS = 'skeleton-animate'

function createSkeletonBlock(className, styles) {
  var el = document.createElement('div')
  el.className = className + ' ' + SKELETON_ANIMATE_CLASS
  if (styles) {
    Object.keys(styles).forEach(function(key) {
      el.style[key] = styles[key]
    })
  }
  return el
}

function createSkeleton(config) {
  var container = document.createElement('div')
  container.className = 'skeleton-container'

  // 标题骨架
  if (config.title !== false) {
    var titleBlock = createSkeletonBlock(SKELETON_TITLE_CLASS, {
      width: config.titleWidth || '40%',
      height: '16px',
      marginBottom: '16px'
    })
    container.appendChild(titleBlock)
  }

  // 头像骨架
  if (config.avatar) {
    var avatarBlock = createSkeletonBlock(SKELETON_AVATAR_CLASS, {
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      marginBottom: '16px'
    })
    container.appendChild(avatarBlock)
  }

  // 行骨架
  var rows = config.rows || 3
  for (var i = 0; i < rows; i++) {
    var isLast = i === rows - 1
    var rowBlock = createSkeletonBlock(SKELETON_ROW_CLASS, {
      width: isLast ? '60%' : '100%',
      height: '14px',
      marginBottom: i < rows - 1 ? '12px' : '0'
    })
    container.appendChild(rowBlock)
  }

  return container
}

function addStyles() {
  if (document.getElementById('skeleton-directive-styles')) return

  var style = document.createElement('style')
  style.id = 'skeleton-directive-styles'
  style.textContent = `
    .skeleton-container {
      padding: 16px;
    }

    .skeleton-animate {
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200% 100%;
      animation: skeleton-loading 1.5s infinite ease-in-out;
      border-radius: 4px;
    }

    @keyframes skeleton-loading {
      0% {
        background-position: 200% 0;
      }
      100% {
        background-position: -200% 0;
      }
    }

    .skeleton-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: #fff;
      z-index: 10;
      overflow: hidden;
    }
  `
  document.head.appendChild(style)
}

export var skeletonDirective = {
  bind: function(el, binding) {
    addStyles()
    el._skeletonOriginalDisplay = el.style.position
    el._skeletonOverlay = null
  },

  inserted: function(el, binding) {
    updateSkeleton(el, binding)
  },

  update: function(el, binding) {
    if (binding.value === binding.oldValue) return
    updateSkeleton(el, binding)
  },

  unbind: function(el) {
    removeSkeleton(el)
  }
}

function updateSkeleton(el, binding) {
  var config = typeof binding.value === 'object' ? binding.value : { loading: !!binding.value }

  if (config.loading) {
    showSkeleton(el, config)
  } else {
    hideSkeleton(el)
  }
}

function showSkeleton(el, config) {
  // 确保父元素有定位
  var position = window.getComputedStyle(el).position
  if (position === 'static') {
    el.style.position = 'relative'
  }

  // 移除已存在的骨架屏
  removeSkeleton(el)

  // 创建骨架屏遮罩
  var overlay = document.createElement('div')
  overlay.className = 'skeleton-overlay'

  // 根据元素高度决定骨架屏数量
  var elHeight = el.offsetHeight || 200
  var skeletonCount = Math.max(1, Math.ceil(elHeight / 150))

  for (var i = 0; i < skeletonCount; i++) {
    var skeleton = createSkeleton(config)
    overlay.appendChild(skeleton)
  }

  el.appendChild(overlay)
  el._skeletonOverlay = overlay
}

function hideSkeleton(el) {
  removeSkeleton(el)
  // 恢复原始定位
  if (el._skeletonOriginalDisplay !== undefined) {
    el.style.position = el._skeletonOriginalDisplay || ''
  }
}

function removeSkeleton(el) {
  if (el._skeletonOverlay && el._skeletonOverlay.parentNode) {
    el._skeletonOverlay.parentNode.removeChild(el._skeletonOverlay)
    el._skeletonOverlay = null
  }
}
